<button class="ft2-btn-pure v-center" type="button">
    <mat-icon class="text-muted icon-xl">{{visible ? 'visibility_off' : 'visibility'}}</mat-icon>
</button>
